/**
 * STICKY ADD BAR — 8 Sep 2026
 *
 * On a product page the real Add to cart sits inside a tall info column; with
 * the pack builder in that column it scrolls off the top of a phone within a
 * screen or two. This bar follows the shopper down the page and presses the
 * real button for them.
 *
 * It used to live inside bundle-qty.js, which now exits at once because bundle
 * pricing is off — so the bar vanished on the draft while live still had it.
 * Pulled out here so it exists whatever the bundle setting is. Same class
 * names as before, so nothing that styled or tested it has to change.
 *
 *  - Skips if bundle-qty.js is active (#BundleTiers present): that script owns
 *    the bar in that mode, and two bars is worse than none.
 *  - Shows only while the real button is OFF screen (above or below), so the
 *    two never compete; hidden again the moment the real one scrolls back in.
 *  - Survives a colour swap: color-ajax-nav.js replaces the product section and
 *    fires shopify:section:load, on which the title and target button re-bind.
 */
(function () {
  'use strict';
  if (document.getElementById('BundleTiers')) return;
  if (document.querySelector('.BundleStickyBar')) return;
  var real = document.querySelector('.ProductForm__AddToCart');
  if (!real) return;

  var css = document.createElement('style');
  css.textContent =
    '.BundleStickyBar{position:fixed;bottom:0;left:0;right:0;z-index:999;transform:translateY(100%);transition:transform .3s ease;background:#fff;border-top:1px solid #e5e5e5;box-shadow:0 -4px 20px rgba(0,0,0,.08);padding:0 0 env(safe-area-inset-bottom)}' +
    '.BundleStickyBar--visible{transform:translateY(0)}' +
    '.BundleStickyBar__Inner{max-width:1200px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;padding:12px 20px;gap:14px}' +
    '.BundleStickyBar__Img{width:44px;height:44px;border-radius:8px;object-fit:cover;flex-shrink:0;border:1px solid #eee}' +
    '.BundleStickyBar__Info{display:flex;flex-direction:column;gap:2px;min-width:0;flex:1}' +
    '.BundleStickyBar__Product{font-size:13px;font-weight:600;color:var(--text-color,#4E4D4D);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.BundleStickyBar__Price{font-size:12px;color:#666}' +
    '.BundleStickyBar__Btn{flex-shrink:0;min-height:44px;padding:0 22px;border:0;border-radius:999px;background:var(--button-background,#4E4D4D);color:#fff;font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;white-space:nowrap}' +
    '.BundleStickyBar__Btn:focus-visible{outline:3px solid #ffd400;outline-offset:2px}' +
    '@media (max-width:400px){.BundleStickyBar__Img{display:none}}' +
    '@media (prefers-reduced-motion:reduce){.BundleStickyBar{transition:none}}';
  document.head.appendChild(css);

  var bar = document.createElement('div');
  bar.className = 'BundleStickyBar';
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', 'Add to cart');
  bar.innerHTML =
    '<div class="BundleStickyBar__Inner">' +
      '<img class="BundleStickyBar__Img" alt="" hidden>' +
      '<div class="BundleStickyBar__Info"><span class="BundleStickyBar__Product"></span><span class="BundleStickyBar__Price"></span></div>' +
      '<button type="button" class="BundleStickyBar__Btn">Add to cart</button>' +
    '</div>';
  document.body.appendChild(bar);
  var img = bar.querySelector('.BundleStickyBar__Img');
  var name = bar.querySelector('.BundleStickyBar__Product');
  var price = bar.querySelector('.BundleStickyBar__Price');
  var btn = bar.querySelector('.BundleStickyBar__Btn');

  function bind() {
    real = document.querySelector('.ProductForm__AddToCart');
    var title = document.querySelector('.ProductMeta__Title');
    var priceEl = document.querySelector('.ProductMeta__Price, .ProductMeta__PriceList .Price');
    var pic = document.querySelector('.Product__Gallery img, .Product__SlideItem img');
    name.textContent = title ? title.textContent.trim() : '';
    price.textContent = priceEl ? priceEl.textContent.trim() : '';
    if (pic && pic.currentSrc) { img.src = pic.currentSrc; img.hidden = false; } else { img.hidden = true; }
    if (real) {
      btn.disabled = real.disabled;
      var label = real.textContent.replace(/[ \t\r\n]+/g, ' ').trim();
      btn.textContent = label || 'Add to cart';
    }
  }
  btn.addEventListener('click', function () {
    if (btn.dataset.packMode === '1') { window.location.href = '/cart'; return; }
    if (!real || real.disabled) return;
    real.click();
  });

  // ── the pack, if this page has one ──────────────────────────────────────────
  // A shopper who has built a pack below should not see a bar offering to add
  // one sarong: she has three in there and no reminder of it. When the pack has
  // anything in it the bar becomes the way back to it, with the count and the
  // real price. The main Add to cart above is left alone — it is how somebody
  // buys a single sarong, and taking that away to show a pack total would break
  // the simpler purchase to serve the bigger one.
  var pack = null;   // { count, total } or null
  function packIds() {
    return [...document.querySelectorAll('.PackBuilder [data-card][data-variant-id]')]
      .map(function (c) { return c.getAttribute('data-variant-id'); });
  }
  function applyPack() {
    if (!pack || !pack.count) {
      // Clear the pack mode before rebinding, or the bar goes on believing it
      // is a "View your pack" button: bind() rewrites the LABEL back to "Add to
      // cart" but the click handler still reads dataset.packMode and sends the
      // shopper to /cart without adding anything. A button that says one thing
      // and does another is worse than either.
      delete btn.dataset.packMode;
      bind();
      return;
    }
    var m = null; try { m = window.formatShopMoney(pack.total); } catch (e) {}
    name.textContent = pack.count + (pack.count === 1 ? ' sarong in your pack' : ' sarongs in your pack');
    price.textContent = m || '';
    img.hidden = true;
    btn.disabled = false;
    btn.textContent = 'View your pack';
    btn.dataset.packMode = '1';
  }
  function readPack() {
    var ids = packIds();
    if (!ids.length) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = 0, cents = 0;
        (cart.items || []).forEach(function (it) {
          if (ids.indexOf(String(it.variant_id)) === -1) return;   // not a pack line
          count += it.quantity;
          cents += (it.final_line_price != null ? it.final_line_price : it.line_price);
        });
        pack = { count: count, total: cents };
        applyPack();
      })
      .catch(function () {});
  }
  // The builder tells us whenever it has re-read the cart, so the bar never
  // makes its own second request that could disagree with the pack's own figure.
  document.addEventListener('pack:money', function (e) { pack = e.detail; applyPack(); });
  readPack();

  var on = false;
  function check() {
    if (!real) return;
    var r = real.getBoundingClientRect();
    var visible = r.bottom > 0 && r.top < window.innerHeight;
    var show = !visible && window.scrollY > 250;
    if (show !== on) { on = show; bar.classList.toggle('BundleStickyBar--visible', show); }
  }
  bind(); check();
  // Scroll events on window did not reliably reach this in the theme's desktop
  // layout, and a colour swap re-lays the page out with no scroll event at all —
  // so a shopper who picked a colour and kept reading never saw the bar. Listen
  // on document in the capture phase too (catches any scrolling element), and
  // poll cheaply as the fallback that makes the bar right whatever happened.
  window.addEventListener('scroll', check, { passive: true });
  document.addEventListener('scroll', check, { capture: true, passive: true });
  window.addEventListener('resize', check);
  setInterval(check, 300);
  document.addEventListener('shopify:section:load', function () {
    bind(); check();
    setTimeout(function () { bind(); check(); }, 400);   // after the swapped section has laid out
  });
})();
